/* Copyright (c) 2021 Caring Transitions Online Auctions. All Rights Reserved. */

// library imports
import { Component, createRef } from 'react';
import { Modal, Button, Form } from 'react-bootstrap';
import Axios from 'axios';
import moment from 'moment';
import * as momentTz from 'moment-timezone';

// project imports
import { getSellerUrl, getSellerHeaders } from 'shared/http';
import { locationlist, loctemplatedetail, loctemplatelist } from 'shared/settings/apiconfig';
import Datatable from 'shared/datatable';
import toast from 'shared/toast';

// style imports
import './LocationTemplateList.scss';
import { ArrayValueReorder } from 'shared/modifiers';
import { NoData } from 'features/components/redirect/NoData';

/**
 * this page is used to render table for location tempaltes
 * 
 * @param props
 * 
 * @returns html code for rendering location template list table
 * 
**/

export class LocationTemplateList extends Component {

    config;

    constructor(props) {
        super(props);
        this.dataTable = createRef();
        this.state = {
            modal: false,
            content: '',
            type: '',
            locationName: '',
            modifiedDate: '',
            locationList: [],
            search: {},
            searchData: true,
            errorpageredirect: false,
            errorType: ''
        };

        if (props.location.state && props.location.state.datatable && props.location.state.datatable.search) {
            const search = [...props.location.state.datatable.search];
            if(search.length > 0){
                search[0]['value'] = search[0]['value'].replace(/(^\*)|(\*$)/g, '');
                this.state['search']['locationid'] = search[0];
            }
        }

        this.config = {
            name: 'location template',
            url: loctemplatelist,
            params: {},
            columns: [
                {
                    name: '', property: 'id', columnType: 'actions', actions: ['edit', 'view'], customHeader: <></>, width:'50px',
                    actionEvents: {
                        edit: (row, state) => { this.props.history.push({ pathname: `/locations/templates/edit/${row['id']}`, state: state }) },
                        view: (row) => this.getTemplateData(row['id'])
                    }
                },
                { name: 'Location', property: 'locationtitle', sort: true, width: '320px' },
                { name: 'Type', property: 'type', sort: true, width: '220px', columnType: 'custom', customColumn: this.customType },
                { name: 'Last Modified', property: 'modifieddate', sort: true, width: '200px', columnType: 'custom', customColumn: this.customDate },
            ],
            sort: [{ field: 'locationtitle', direction: 'asc' }],
            pagination: true,
            field: ['id', 'locationid', 'locationtitle', 'type', 'modifieddate']
        };
    }

    componentDidMount() {
        this.getLocationList();
        window.history.pushState(null, null, window.location.pathname);
        window.addEventListener('popstate', this.onBack);
    }
    onBack = (e) => {
        e.preventDefault();
        window.history.pushState(null, null, window.location.pathname);
    }

    getLocationList = async () => {
        await Axios.post(getSellerUrl(locationlist), JSON.stringify({ field: ['id', 'title'] }), getSellerHeaders())
            .then(response => {
                this.setState({
                    locationList: ArrayValueReorder([...response.data['data']], 'title')
                })
            })
            .catch(error => {
                if(error.response.status == 401 || error.response.status == 404) {
                    this.setState({
                        errorpageredirect: true,
                        errorType: error.response.status == 401 ? 'expiryError' : error.response.status == 404 ? 'noData' : ''
                    })
                }
            });
    };

    getTemplateData = (templateId) => {
        Axios.get(getSellerUrl(`${loctemplatedetail}/${templateId}`), getSellerHeaders())
            .then(response => {
                this.setState({
                    modal: true,
                    locationName: response.data['data'][0]['locationtitle'],
                    type: response.data['data'][0]['type'],
                    content: JSON.parse(response.data['data'][0]['content'])['body'],
                    modifiedDate: this.customDate(response.data['data'][0])
                });
            })
            .catch(error => {
                toast.error(error.response.data['message']);
            });
    };

    customDate = (value) => {
        if (value['modifieddate']) {
            return `${moment.utc(value['modifieddate']).local().format('MM/DD/YYYY hh:mm A')} ${momentTz.tz(momentTz.tz.guess()).zoneAbbr()}`;
        }

        return '- - -';
    };

    customType = (value) => {
        if (value['type'] === 'T & C')
            return 'Terms & Conditions';
        else
            return value['type'];

    };


    changeLocation = (event) => {

        let eventValue = event.target.value
        this.setState({
            search: { locationid: { field: 'locationid', value: eventValue, op: 'LIKE', join: 'AND' } },
            searchData: true
        }, () => {
            this.dataTable.current.searchData();
        });
    };

    render() {
        if (this.state.errorpageredirect) {
            return <NoData {...this.props} type={this.state.errorType} />
        }

        return (
            <div className="d-flex flex-column location-template">
                <div className="d-flex flex-column flex-sm-row mb-2">
                    <Form.Control as="select" className="search-field" defaultValue={null} disabled={!this.state.locationList.length} value={this.state?.search?.locationid?.value} onChange={this.changeLocation}>
                        <option value={""}>All Location</option>
                        {
                            this.state.locationList.map((location, idx) => <option key={idx} value={location['id']}>{location['title']}</option>)
                        }
                    </Form.Control>
                    {/* <Form.Control type="text" className="ml-0 my-2 ml-sm-3 my-sm-0 search-field" placeholder="Search" disabled={!this.state.locationList.length} /> */}
                </div>
                {/* need to add props, as it provides the previous state of datatable */}
                <Datatable {...this.props} ref={this.dataTable} config={{ ...this.config }} search={this.state.searchData ? { search: { ...this.state.search }, searchData: this.state.searchData } : null} />
                <Modal  id="templateView" show={this.state.modal} size="lg" className="templateModal" animation={false} keyboard={false} onHide={() => { this.setState({ ...this.state }) }} >
                    <Modal.Header className="" style={{ backgroundColor: '#00263E', color: 'white' }}>
                        <div className="d-flex flex-row justify-content-between w-100">
                            <div className="d-flex flex-column">
                                <span className="">Location</span>
                                <span>{this.state.locationName}</span>
                                <span className="">{this.state.type === 'T & C' ? 'Terms & Conditions' : this.state.type}</span>
                            </div>
                            <div className="d-flex flex-column justify-content-center align-items-center">
                                <span className="">Last Modified</span>
                                <span>{this.state.modifiedDate}</span>
                            </div>
                        </div>
                    </Modal.Header>
                    <Modal.Body>
                        <div className="ql-editor" style={{ padding: "1rem" }} dangerouslySetInnerHTML={{ __html: this.state.content }} />
                    </Modal.Body>
                    <Modal.Footer className="justify-content-center">
                        <Button variant="secondary" onClick={() => this.setState({ modal: false })}>Close</Button>
                    </Modal.Footer>
                </Modal>
            </div>
        );
    }
}